<template>
  <div class="container">
      <!-- 查询表单 -->
      <!-- <el-input size="mini" type="number" v-model="queryForm.user_id" placeholder="请输入用户ID"></el-input> -->
      <NumberInput number-only :placeholder="'请输入用户ID'"  v-model="queryForm.user_id" :width="160" />
      <NumberInput number-only :placeholder="'请输入用户手机号'"  v-model="queryForm.mobile_phone" :width="160" />
      <!-- <el-input size="mini" type="number" v-model="queryForm.mobile_phone" placeholder="请输入用户手机号"></el-input> -->
      <el-select v-model="queryForm.buy_status" placeholder="是否购买" size="mini">
          <el-option v-for="item in identityOptions" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
      </el-select>
      <el-date-picker size="mini" v-model="queryForm.paid_at_start" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择开始时间">
        </el-date-picker>
        ~
        <el-date-picker size="mini" v-model="queryForm.paid_at_end" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" default-time="23:59:59" placeholder="请选择结束时间">
        </el-date-picker>
      <el-button type="primary" size="mini" @click="handleSearch">搜索</el-button>
      <el-button type="primary" size="mini" @click="handleExport">导出</el-button>
      <!-- 数据表格 -->
      <el-row>
          <el-table v-loading="loading" :data="tableData" border size="mini" :stripe="true" style="width: 100%; margin: 10px 0">
              <el-table-column prop="user_id" label="ID" min-width="120"></el-table-column>
              <el-table-column prop="nickname" label="用户昵称" min-width="120"></el-table-column>
              <el-table-column prop="mobile_phone" label="手机号" width="130"></el-table-column>
              <el-table-column prop="buy_status_text" label="是否购买" width="100"></el-table-column>
              <el-table-column prop="paid_at" label="购买时间" width="220"></el-table-column>
              <el-table-column prop="amount" label="分润金额" width="220"></el-table-column>
          </el-table>
      </el-row>
      <el-row>
            <div class="block">
                <el-pagination background @current-change="getList" :current-page.sync="queryForm.page" :page-size="queryForm.limit"
                               layout="total, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </el-row>
  </div>
</template>

<script>
import { promoterlist } from "@/api/luminaryplan"
import NumberInput from "@/components/number_input.vue";
export default {
  data() {
      return {
          queryForm: {
            user_id: "",
            mobile_phone: "",
              identity: "",
              paid_at_start: "",
              paid_at_end: "",
              buy_status: "",
              page: 1,
              limit: 10,
              luminary_user_id:this.$route.query.id
          },
          identityOptions: [
              { value: '0', label: "全部" },
              { value: '1', label: "是" },
              { value: '2', label: "否" },
          ],
          loading: false,
          tableData: [
              // 示例数据
              {
                  id: 1001,
                  nickname: "测试用户",
                  mobile: "13800138000",
                  identity: "代理商",
                  startDate: "2023-01-01",
                  endDate: "2024-01-01",
                  remainingDays: 200,
                  totalAmount: "5000.00",
                  withdrawable: "3000.00",
                  promotionCount: 50,
              },
              {
                  id: 1002,
                  nickname: "测试用户",
                  mobile: "13800138000",
                  identity: "代理商",
                  startDate: "2023-01-01",
                  endDate: "2024-01-01",
                  remainingDays: 200,
                  totalAmount: "5000.00",
                  withdrawable: "3000.00",
                  promotionCount: 50,
              },
          ],
          total:0,
      };
  },
  components: {
      NumberInput,
  },
  mounted() {
      this.getList();
  },
  methods: {
      handleSearch() {
        this.queryForm.page = 1;
        this.getList();

      },
      handleExport() {
        const params = new URLSearchParams();
        const fullUrl = window.location.origin;
        // 遍历 queryForm，只添加有值的参数
        Object.entries(this.queryForm).forEach(([key, value]) => {
          if (value !== null && value !== undefined) {
            params.append(key, value);
          }
        });
        // http://dev.admin.defen.hzxinquanzi.com/ https://backend.zhangdefenspace.com/
        const url = `${fullUrl}/backend/activity/luminary/promoter/list/export?${params.toString()}`;
        // window.open(url, '_blank');
        location.href = url;
      },
      handleSelectionChange(val) {
            this.multipleSelection = val;
            console.log("多选选择：", val);
      },
      getList() {
          this.loading = true;
          promoterlist(this.queryForm).then((res) => {
              if (res.code === 1) {
                  this.tableData = res.data.list;
                  this.total = res.data.total; 
              }
              this.loading = false; 
          })
      }
  },
};
</script>

<style scoped>
.container {
  padding: 20px 10px;
}
.container .el-input {
  width: 200px;
  margin: 0 10px 10px;
}
.container .showAuthDialog .el-input {
  width: 300px;
}
.container .showAuthDialog .el-form-item {
  margin-bottom: 0px;
}
.el-table {
  margin-top: 10px;
  /* box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1); */
}
</style>
